import React from 'react';

import Container from '@src/components/Shared/Container';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';
import NextImage from '@src/components/Shared/NextImage';

import { MultiQuotesPropTypes } from './MultiQuotes.types';

const MultiQuotes: React.FC<MultiQuotesPropTypes> = ({ attr, id, testimonials }) => {
  return (
    <Container attr={attr} id={id}>
      <div className='grid gap-[2.4rem] md:grid-cols-2 lg:grid-cols-3'>
        {testimonials?.map((testimonial) => {
          return (
            <div
              key={`${testimonial?.sys?.id}-testimonial`}
              className='border-border flex flex-col justify-between rounded-lg border-[0.1rem] p-[2.5rem]'
            >
              <div>
                <p
                  style={{
                    textShadow: 'rgb(143, 66, 0, 0.2) 1px 0px 0px, rgb(143, 66, 0, 0.2) 0.540302px 0.841471px 0px',
                  }}
                  className='heading-[2.4rem] text-primary mb-[2rem] text-[1.4rem] font-medium uppercase'
                >
                  {testimonial?.title}
                </p>
                <RenderBodyCopy className='mb-[3.2rem]' bodyCopy={testimonial.bodyCopy?.json?.content} />
              </div>
              <div className='mt-[3rem] flex items-end justify-end gap-[1rem]'>
                <div className='mb-[0.5rem] text-right md:mb-[0]'>
                  <h3 className='mb-[0.6rem] text-[1.2rem] font-bold uppercase md:text-[1.8rem]'>
                    {testimonial?.name}
                  </h3>
                  <p className='text-header-copy ml-auto text-[1.2rem] leading-none font-normal uppercase md:text-[1.8rem] md:leading-[2.3rem]'>
                    {testimonial?.company}
                  </p>
                </div>

                <NextImage
                  src={testimonial?.logo?.url}
                  alt='A portrait'
                  className='w-[6rem] md:w-[12rem]'
                  objectFit='cover'
                />
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default MultiQuotes;
